import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

// Angular keeps a page alive when only its route params change, so an edit
// page opened for one record and then moved (Previous / Next) to another
// would still show the first. Routes with data { reloadOnParamChange: true }
// get a fresh page whenever their params change instead.
@Injectable()
export class ReloadOnParamChangeStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) return false;
    if (future.data?.['reloadOnParamChange']) {
      return JSON.stringify(future.params) === JSON.stringify(curr.params);
    }
    return true;
  }
}
